import React, { useRef, useEffect } from 'react';
import {
  StyledAlert,
  AlertIcon,
  AlertMessageItem,
  AlertTextContainer,
  AlertClose,
} from './AlertStyles';
import { alertAppearance } from './AlertConstants';

interface Props {
  message: string[] | string;
  shouldScrollOnUpdate?: boolean;
  appearance?: alertAppearance;
  onRequestClose?(): void;
}

export const Alert: React.FC<Props> = ({
  shouldScrollOnUpdate = true,
  appearance = 'danger',
  message,
  onRequestClose,
}) => {
  const alertRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (shouldScrollOnUpdate && alertRef.current) {
      alertRef.current.scrollIntoView({ block: 'end', behavior: 'smooth' });
    }
  }, [message, shouldScrollOnUpdate]);

  return (
    <StyledAlert ref={alertRef} appearance={appearance}>
      <AlertIcon appearance={appearance} />
      <AlertTextContainer>
        {onRequestClose && <AlertClose prependIcon="fal fa-times" onClick={onRequestClose} />}
        {(typeof message === 'string' ? [message] : message).map((text, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <AlertMessageItem key={index}>{text}</AlertMessageItem>
        ))}
      </AlertTextContainer>
    </StyledAlert>
  );
};
